import React from "react";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Typography,
} from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styles from "./WalletManagement.module.scss";
import { routes } from "../../../../../../constants";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import { addFundToWalletAction } from "../../../../../../redux/services/wallet-management/walletManagementServices";
import { allowCharactersOnlyForIntegerNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";

const WalletManagementForm = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dispatch dependencies */
  const dispatch = useDispatch();
  /* dispatch dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* id dependencies */
  const { selectedWalletManagementId } = useSelector((state) => state.walletManagement);
  /* id dependencies */

  useEffect(()=>{
    if (
      !selectedWalletManagementId ||
      selectedWalletManagementId === "" ||
      selectedWalletManagementId === null ||
      selectedWalletManagementId === undefined
    ) {
      navigate(baseRouteMakerForSuperAdmin(routes.WALLET_MANAGEMENT))
    }
  },[selectedWalletManagementId])

  const onSubmit = (values) => {
    const {amount,...rest} = values;
    const dataToBeSent = {
      ...rest,
      amount:Number(amount),
      customer_id:selectedWalletManagementId
    }

    dispatch(addFundToWalletAction(dataToBeSent, navigate, setLoading))
  };

  return (
    <div className={styles.configurationContainer}>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(baseRouteMakerForSuperAdmin(routes.WALLET_MANAGEMENT))
            }
          />
          <Typography.Title level={2}>
            {t("Modules.WalletManagement.addFund")}
          </Typography.Title>
        </Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          style={{ maxWidth: "400px" }}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={24}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.WalletInfo.amount")}
                  required={true}
                />
              }
              name="amount"
              rules={[
                {
                  required: true,
                  message: t("Modules.WalletInfo.pleaseEnterAmount"),
                },
                {
                  validator: (_, value) => {
                    if (value && value < 1)
                      return Promise.reject(
                        `${t("Modules.WalletInfo.amount")} ${t(
                          "CommonUtils.shouldBeGreaterThan0"
                        )}`
                      );
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                type="number"
                placeholder={t("Modules.WalletInfo.enterAmount")}
                onKeyDown={(e) => allowCharactersOnlyForIntegerNumbers(e)}
              />
            </Form.Item>
          </Col>

            <Col span={24}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.Notify.description")}
                    required={true}
                  />
                }
                name="description"
                rules={[
                  {
                    required: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                ]}
                // normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <TextArea
                 rows={4} 
                 showCount
                 maxLength={appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA}
                 placeholder={t("CommonUtils.enterDescriptionUpto255Characters")}
                 /> 
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.add")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default WalletManagementForm;
